interface IProductStockProps {
  quantity: number;
}

export const ProductStock: React.FC<IProductStockProps> = ({ quantity }) => {
  return quantity === 1 ? (
    <b style={{ color: "#ff5c5f" }}>Only {quantity} left!</b>
  ) : quantity > 1 ? (
    <b>{quantity} in stock</b>
  ) : (
    <b style={{ color: "#ff5c5f" }}>Out of stock</b>
  );
};
